import { useEffect } from "react";
import { CONSOLE_URL } from "@/lib/sites";

/** Shop sign-up moved to the console's step-by-step "Join PawBazaar" (ALL-2);
 *  old links to /vendor/register land there. */
export default function VendorRegister() {
  useEffect(() => { window.location.replace(`${CONSOLE_URL}/join/shop`); }, []);
  return <div className="min-h-[50vh] grid place-items-center text-sm text-stone-500">Opening shop sign-up…</div>;
}
